<div class="error" *ngIf="error.type === 'dialog'">
  <h2>{{ error.title ? error.title : 'An error occured' }}</h2>
  <p>{{ error.message }}</p>
</div>
